export const validateNewQuery = (query = {}, portOperations = []) => {
    let errors = []
    const { name = '', access = '', laycanStartDate = null, laycanEndDate = null, freightMode = '', qtyMode = '', message = '' } = query || {}
    if (!name) errors.push('Query Name is Required')
    if (!access) errors.push('Access Mode is Required')
    if (!freightMode) errors.push('Freight mode is Required')
    if (!qtyMode) errors.push('Qty option is Required')
    if (qtyMode === "MINMAX") {
        const loadingOps = portOperations?.filter(
            (item) => item.operation === "Loading"
        ) || [];

        loadingOps.forEach((item, index) => {
            if (item.min == null) errors.push(`Min is required for loading row ${index + 1}`);
            if (item.max == null) errors.push(`Max is required for loading row ${index + 1}`);

            if (item.min < 0) errors.push(`Min must be greater than 0 (row ${index + 1})`);
            if (item.max <= 0) errors.push(`Max must be greater than 0 (row ${index + 1})`);

            if (item.min > item.max) {
                errors.push(`Min must be ≤ Max (row ${index + 1})`);
            }
        });
    }
    if (!laycanStartDate) errors.push('Laycan start date is Required')
    if (!laycanEndDate) errors.push('Laycan end date is Required')
    // if (message && String(message).length) errors.push('Message max character length of 4000 exceded')

    if (Array.isArray(portOperations)) {
        for (let i = 0; i < portOperations.length; i++) {
            const item = portOperations[i]
            if (item?.operation?.toLowerCase() === "loading" || item?.operation?.toLowerCase() === "discharging") {
                if (!item.port) errors.push(`${item.operation} PORT is required`)
                if (item.rate <= 0) errors.push(`${item.operation} RATE must be greater than 0`)
                if (Number(item.turnTime) > 2) errors.push(`${item.operation} TURN TIME must be less than or equal to 2 days`)
            }
        }
    }
    if (portOperations[portOperations?.length - 1]?.operation === "Loading") {
        errors.push('Loading is not possible at last operation')
    }
    return {
        isValid: errors.length === 0,
        errors
    }
}